import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const emptyFn = function emptyFn() {};

class Dots extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array.isRequired,
        tmpl: PropTypes.func.isRequired,
        step: PropTypes.func.isRequired,
        current: PropTypes.number.isRequired,
        dotsAction: PropTypes.string,
        dotStyle: PropTypes.string,
        dotCurrentStyle: PropTypes.string,
        extension: PropTypes.number,
    };
    static defaultProps = {};

    render() {
        const { content, tmpl, step, current, dotsAction, dotStyle, dotCurrentStyle, extension } = this.props;

        const clickFn = dotsAction === 'click' ? step : emptyFn;

        const hoverFn = dotsAction === 'hover' ? step : emptyFn;

        return (
            <div ifeng_ui_pc_sliders-dots="">
                {content.map((item, index) => (
                    <div
                        onClick={clickFn}
                        onMouseEnter={hoverFn}
                        key={index}
                        index={index + extension}
                        className={
                            current === index + extension
                                ? `${dotCurrentStyle} ${styles.current}`
                                : `${dotStyle} ${styles.dot}`
                        }>
                        {tmpl(item, index)}
                    </div>
                ))}
            </div>
        );
    }
}

export default Dots;
